var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriorityMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EFAE07"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8812 20.7471H21.7355C21.2814 20.7471 20.9027 20.3999 20.8634 19.9475L20.1552 11.8032C20.0962 11.125 20.4574 10.4796 21.0663 10.1752C21.5334 9.9416 22.0833 9.9416 22.5505 10.1752C23.1593 10.4796 23.5205 11.125 23.4615 11.8032L22.7533 19.9475C22.714 20.3999 22.3353 20.7471 21.8812 20.7471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5589 24.2494C23.5589 25.2164 22.775 26.0003 21.808 26.0003C20.841 26.0003 20.0571 25.2164 20.0571 24.2494C20.0571 23.2824 20.841 22.4985 21.808 22.4985C22.775 22.4985 23.5589 23.2824 23.5589 24.2494Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8241 20.7471H14.6784C14.2243 20.7471 13.8456 20.3999 13.8063 19.9475L13.0981 11.8032C13.0391 11.125 13.4003 10.4796 14.0091 10.1752C14.4763 9.9416 15.0262 9.9416 15.4933 10.1752C16.1022 10.4796 16.4634 11.125 16.4044 11.8032L15.6962 19.9475C15.6569 20.3999 15.2782 20.7471 14.8241 20.7471Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5017 24.2494C16.5017 25.2164 15.7179 26.0003 14.7509 26.0003C13.7839 26.0003 13 25.2164 13 24.2494C13 23.2824 13.7839 22.4985 14.7509 22.4985C15.7179 22.4985 16.5017 23.2824 16.5017 24.2494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityMedium);
export default __webpack_public_path__ + "static/media/priority-medium.5bca43b732570aff66a78666c56d6941.svg";
export { ForwardRef as ReactComponent };